var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturedStationNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flag-plain-1 copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "detail-panel",
    transform: "translate(-20.000000, -360.000000)",
    fill: "#FF9900",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "featured-station-note",
    transform: "translate(20.000000, 358.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag-plain-1-copy",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3957219,2.88770053 L7.44385027,2.88770053 C7.3729688,2.88770053 7.31550802,2.95952651 7.31550802,3.04812834 L7.31550802,8.19786096 C7.31550802,8.46366646 7.14312568,8.67914439 6.93048128,8.67914439 C6.71783689,8.67914439 6.54545455,8.46366646 6.54545455,8.19786096 L6.54545455,1.92513369 C6.54545455,1.3935227 6.20068986,0.962566845 5.77540107,0.962566845 L2.69518717,0.962566845 C2.55342424,0.962566845 2.43850267,1.1062188 2.43850267,1.28342246 L2.43850267,8.98395722 C2.43850267,9.16116088 2.55342424,9.30481283 2.69518717,9.30481283 L4.86673797,9.30481283 C4.51621865,9.53518458 4.23500134,9.90156876 4.06536898,10.348877 C4.00173063,10.5467508 4.02089327,10.7712158 4.11650325,10.9478472 C4.21211324,11.1244787 4.37167699,11.2301958 4.54228877,11.229947 L10.3946952,11.229947 C10.819984,11.229947 11.1647487,10.7989907 11.1647487,10.2673797 L11.1647487,3.85026738 C11.1647487,3.3191572 10.8206097,2.88840868 10.3957219,2.88770053 L10.3957219,2.88770053 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.898395722,0 C0.473106931,0 0.128342246,0.430955856 0.128342246,0.962566845 L0.128342246,14.4385027 C0.128342246,14.9701137 0.473106935,15.4010695 0.898395722,15.4010695 C1.32368451,15.4010695 1.6684492,14.9701137 1.6684492,14.4385027 L1.6684492,0.962566845 C1.6684492,0.430955856 1.32368451,0 0.898395722,0 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedStationNote);
export default __webpack_public_path__ + "static/media/featuredStationNote.357fae30a95451d9543b029dc71238fb.svg";
export { ForwardRef as ReactComponent };